import React, { useReducer } from 'react'
export const TimeContext = React.createContext({})

const initialState = {
  gap: 0,
}


const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_GAP':
      return {
        gap: action.payload
      }
    default:
      throw new Error()
  }
}


export const TimeContextProvider = (Children) => {
  const Provider = props => {
    const [state, dispatch] = useReducer(reducer, initialState)
    return (
      <TimeContext.Provider value={{...state, dispatch, getServerTime: () => Date.now() + state.gap}}>
        <Children {...props} />
      </TimeContext.Provider>
    )
  }
  return Provider
}
